import React from 'react';

// Last Updated: 2025-11-19
export const cleaningPricing = {
    mattresses: [
        { item: 'Colchón Individual', price: '$35 - $40' },
        { item: 'Colchón Matrimonial', price: '$35 - $40' },
        { item: 'Colchón Queen', price: '$55 - $65' },
        { item: 'Colchón King', price: '$55 - $65' },
    ],
    furniture: [
        { item: 'Mueble Individual (1 plaza)', price: '$25' },
        { item: 'Mueble de 2 plazas', price: '$35' },
        { item: 'Mueble de 3 plazas', price: '$40' },
        { item: 'Mueble de 4 plazas', price: '$45' },
        { item: 'Mueble de 5 plazas', price: '$50' },
    ],
    packages: [
        { item: 'Juego de Sala (3+1+1)', price: '$55' },
        { item: 'Juego de Sala (3+2+1)', price: '$65' },
        { item: 'Juego de Sala (3+2+2)', price: '$75' },
        { item: 'Juego de Sala (3+3+1)', price: '$80' },
        { item: 'Juego de Sala (Esquinero + 1)', price: '$85' },
        { item: 'Juego de Sala (Esquinero + 2)', price: '$90' },
    ],
};
